import styled, { css } from '@xstyled/styled-components';
import React, { FC } from 'react';

interface ArrowProps {
  placement?: string | undefined;
}

const Arrow = styled.div<ArrowProps>`
  ::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border: 10px solid transparent;
    border-top: 10px solid ${p => p.theme.colors.yellowLight};
    margin-top: 14px;
    z-index: 1;
    right: ${p => (p.placement == 'bottom-right' ? '20px' : null)};
    left: ${p => (p.placement === 'left' ? '-17px' : null)};
    top: ${p => (p.placement === 'left' ? '0' : null)};
    transform: ${p => (p.placement === 'left' ? 'rotate(90deg)' : null)};
    ${p =>
      p.placement === 'top-right'
        ? css`
            top: -10px;
            right: 20px;
            border-top: none;
            border-bottom: 10px solid ${p => p.theme.colors.yellowLight};
            margin-top: 0;
          `
        : null}
    ${p =>
      p.placement === 'bottom-center-up'
        ? css`
            top: -10px;
            right: 20px;
            border-top: none;
            border-bottom: 10px solid ${p => p.theme.colors.yellowLight};
            margin-top: 0;
          `
        : null}
  }
`;

interface TooltipProps {
  placement?: string | undefined;
  right?: string | undefined;
  bottom?: string | undefined;
  left?: string | undefined;
  top?: string | undefined;
}

const TooltipBox = styled.div<TooltipProps>`
  position: absolute;
  color: black;
  background-color: yellowLight;
  min-width: 175px;
  padding: 16px;
  border-radius: 8px;
  border: 2px solid;
  font-family: default;
  font-size: 16px;
  text-align: left;

  ::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border: 10px solid transparent;
    border-top: 10px solid ${p => p.theme.colors.black};
    bottom: auto;
    margin-top: 17px;
    right: ${p => (p.placement == 'bottom-right' ? '20px' : undefined)};
    left: ${p => (p.placement === 'left' ? '-20px' : null)};
    top: ${p => (p.placement === 'left' ? '-3px' : null)};
    transform: ${p => (p.placement === 'left' ? 'rotate(90deg)' : null)};
    ${p =>
      p.placement === 'top-right'
        ? css`
            top: -39px;
            right: 20px;
            transform: rotate(180deg);
          `
        : null}
    ${p =>
      p.placement === 'bottom-center-up'
        ? css`
            top: -13px;
            right: 20px;
            border-top: none;
            border-bottom: 10px solid ${p => p.theme.colors.black};
            margin-top: 0;
          `
        : null}
  }
  right: ${p => p.right};
  bottom: ${p => p.bottom};
  left: ${p => p.left};
  top: ${p => p.top};
`;

interface Props {
  left?: string | undefined;
  top?: string | undefined;
  right?: string | undefined;
  bottom?: string | undefined;
  placement?: string | undefined;
  className?: string | undefined;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const Tooltip: FC<Props> = ({ children, ...props }) => {
  return (
    <TooltipBox {...props}>
      {children}
      <Arrow placement={props.placement} />
    </TooltipBox>
  );
};

Tooltip.defaultProps = {
  placement: 'left-bottom',
  right: undefined,
  bottom: undefined
};
